<template lang="pug">
.card.shadow.mb-4()
  .card-header.py-3
    h3.m-0.font-weight-bold.text-primary Create RMA 
    i.nav-item.fas.fa-fw.fa-times.closeModal.pointer(@click="closeModal()")
  .card-body
    .createRMAForm(v-if="!loading")
      .col-12
        h4 Order: {{order.orderName}}
      .col-12
        p Please check Item(s) and enter quantity to be returned: 
        table
          thead
            tr
              th 
                input(type="checkbox" v-model="allSelected" @click="selectAll")
              th Image
              th Item
              th Quantity
          tbody
            tr(v-for="(item,index) in order.orderLineItems")
              td
                input(:id="index" type="checkbox" v-model="selected" :value="index" :disabled="item.quantity - item.rmaQuantity == 0") 
              td
                img.item-image(v-if="item.image" :src="item.image")
                img.item-image(v-if="!item.image" src="@/assets/img/default-image.png")
              td 
                label(v-bind:for="index") {{item.title}}
              td 
                v-select.v-select( 
                  :options="returnQuantityOptions(item.quantity - item.rmaQuantity)" 
                  :disabled="item.quantity - item.rmaQuantity == 0"
                  v-model="item.rmaAvailableQty"
                  :clearable="false"
                )
      .col-12
        p Please provide a reason for return:        
        select(v-model="rma.reason")
          option(value="Looks different to image on site") Looks different to image on site
          option(value="Arrived too late") Arrived too late
          option(value="Poor quality / Faulty") Poor quality / Faulty
          option(value="Incorrect item received") Incorrect item received
          option(value="Doesn't suit me") Doesn't suit me
      .col-12
        p Note:
        textarea-autosize(v-model="rma.note" placeholder="Write your additional notes here, max 200 characters." maxlength="200")
      .col-12
        p Email:
        input(type="email" v-model="rma.email")
      .col-12.text-right
        button.btn.btn-primary(v-on:click="createRMA") Save
</template>

<script>

import { mapState, mapActions } from "vuex";
import convert from 'convert-units'
import moment from 'moment';
import { cloneDeep } from 'lodash';

export default {
  name: 'CreateRMA',
  components:{ },
  props: {    
    orderInfo: Object,
  },
  data() {
    return{
      loading:true,
      order:null,
      allSelected:false,
      rma:{
        email:'',
        items:[],
        reason: 'Looks different to image on site'
      },
      selected:[]
    }
  },
  watch:{ },
  computed:{
    ...mapState(['shopifyChannels','apiChannels', 'amazonChannels']),
  },
  methods:{
    ...mapActions(['updateUser']),
    async closeModal(){
      this.$emit('closeOrder');
    },
    async createRMA(){
      if (!this.validate()) {
        return;
      }

      this.flash('Creating RMA...', 'info');
      let bodyFormData = new FormData();  
      this.rma.items = this.selected.map((checkIdx) => {
        const {id: itemId, rmaAvailableQty: quantity } = this.order.orderLineItems[checkIdx]
        return { itemId, quantity }
      });

      bodyFormData.append('orderName', this.rma.orderName);
      bodyFormData.append('channel', this.rma.channel);
      bodyFormData.append('email', this.rma.email);
      bodyFormData.append('reason', this.rma.reason);
      bodyFormData.append('note', this.rma.note);
      bodyFormData.append('items', JSON.stringify({items:this.rma.items}));

      let response = await this.axios.post('/rp/server/rma',bodyFormData);
      if(response.data.rma) {
        this.updateUser()
        this.flash('RMA Created', 'success');
        this.$emit('closeOrder');
        this.$emit('init');
        }
      else if(response.data.error) {
        this.flash(response.data.error.message, 'error');
      }
    },
    validate() {
      if (this.selected.length === 0) {
        this.flash('Please select at least one item', 'error');
        return false;
      }

      let hasSelectedQty = false;
      this.selected.forEach((checkIdx) => {
        if(!this.order.orderLineItems[checkIdx].rmaAvailableQty) {
          hasSelectedQty = true;
        }
      });
      if (hasSelectedQty) {
        this.flash('Please select the item quantity', 'error');
        return false;
      }

      if (!this.rma.email) {
        this.flash('Please fill out the email field', 'error');
        return false;
      }
      
      return true;
    },
    selectAll(){
      if (!this.allSelected) {
        this.selected = [];
        for (let i =0; i< this.order.orderLineItems.length; i++) {
            this.selected.push(i)
        }
      }else{
        this.selected = []
      }
    },
    returnQuantityOptions(quantity) {
      return [...Array(quantity).keys()]
        .map((item) => item + 1)
        // .map((item) => ({label: item.toString(), value: item}))
    },
  },
  async mounted(){
    //NOTE: need deep clone the props, otherwise it won't cause this component update
    this.order = cloneDeep(this.orderInfo);
    const { orderName, channel } = this.order;
    Object.assign(this.rma, { orderName, channel })
    this.loading = false;

    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeOrder");
      }
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .col-12{
    margin-top:10px;
  }
  p{
    margin-bottom:0;
  }
  textarea{
    width:100%;
  }
  .closeModal{
    position:absolute;
    right:20px;
    top:20px;
  }
  td,th{
    padding:5px 20px;
  }
  .item-image{
    width: 50px;
  }
</style>
<style lang="scss">
  // NOTE: Add another un-scoped style to make it run 
  .v-select {
    .vs__dropdown-menu {
      min-width: 30px;
    } 
  }
</style>